// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"FQ-z","categoryName":"GQ-z","categoryNameSearchHeader":"HQ-z","categoryContent":"IQ-z","bottomAligned":"JQ-z","image":"KQ-z","imageNoBackground":"LQ-z"};